import { StatusesGridView } from '~/components/catalog/statuses/grid';
import { PageContainer } from '~/components/page-container';

export function Statuses() {
	return (
		<PageContainer>
			<StatusesGridView />
		</PageContainer>
	);
}
